import React from 'react';
import { personalData } from '../data';

const Services = () => {
  return (
    <section id="services" className="section">
      <h2 className="section-title">Consultancy Services</h2>
      <div className="section-content">
        <ul className="services-list">
          {personalData.services.map((service, index) => (
            <li key={index}>{service}</li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Services;
